export interface Product {
  id: string;
  code: string;
  name: string;
  media: Media[];
  prices: Price[];
  highlights: string[];
  description: string;
  highLevelDescription: string;
  classification: Classification;
  minimumPrice?: number | null;
  maximumPrice?: number | null;
  monthlyMinimumPrice?: number | null;
  monthlyMaximumPrice?: number | null;
  attributes?: ProductAttributes | null;
}

export interface ProductAttributes {
  amountSolarPanels: number | null;
  grantAmountAvailable: number | null;
}

export interface Classification {
  id: string;
  created: Date | string;
  modified: Date | string;
  code: string;
  name: string;
}

export interface Price {
  price: number;
  roundingMethod: string;
  taxId: string;
  stripePriceId?: number;
  paymentType?: string;
  xeroAccountCodeId?: string;
  xeroAccountCode?: string;
  id?: string;
}

export interface Media {
  mediaFiles: MediaFile[];
  id: string;
  mediaType: string;
  mimeType?: string;
  modified?: Date | string;
  description?: string;
  created?: Date | string;
}

export interface MediaFile {
  created?: Date | string;
  id: string;
  mediaId: string;
  modified?: Date | string;
  sizeType: string;
  url: string;
}

export enum EMediaType {
  Image = 'Image',
  Video = 'Video'
}

export enum ESizeType {
  Thumbnail = 'Thumbnail',
  Original = 'Original'
}

export enum EPaymentType {
  MONTHLY = 'Monthly',
  ONE = 'Once'
}
